import type { RichMediaLayout as MediaSingleLayout } from '@atlaskit/adf-schema';

export const wrappedLayouts: MediaSingleLayout[] = [
	'wrap-left',
	'wrap-right',
	'align-end',
	'align-start',
];
